import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import app from './firebaseApp.js';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

/**
 * Deuxième argument de getFunctions :
 * - région courte : ex. `us-central1` → URL callables `https://REGION-PROJECT.cloudfunctions.net/nom`
 * - ou **origine seule** : `https://us-central1-PROJECT.cloudfunctions.net` (sans chemin /nomDeFonction)
 * Si l’URL contient un chemin (ex. copié depuis Cloud Run en minuscules), le SDK concatène encore le nom
 * camelCase → double segment → **404**. On ne garde que `origin`.
 */
function parseFunctionsConnectParam() {
  const raw = (import.meta.env.VITE_FIREBASE_FUNCTIONS_REGION || 'us-central1').trim();
  if (!raw) return { connect: 'us-central1', isCustomOrigin: false };
  if (/^https?:\/\//i.test(raw)) {
    try {
      return { connect: new URL(raw).origin, isCustomOrigin: true };
    } catch {
      return { connect: 'us-central1', isCustomOrigin: false };
    }
  }
  return { connect: raw, isCustomOrigin: false };
}

const { connect: functionsConnect, isCustomOrigin: functionsUseOrigin } = parseFunctionsConnectParam();

export const auth = getAuth(app);
export const functions = getFunctions(app, functionsConnect);

/**
 * URL absolue d’une callable v2 (évite les 404 si la résolution interne du SDK dérape).
 * @param {string} name - export exact côté Functions, ex. `linkPocketDealRecipient`
 */
export function httpsCallableCloudUrl(name) {
  const pid = firebaseConfig.projectId || '';
  if (!pid) {
    throw new Error('VITE_FIREBASE_PROJECT_ID is required for callable URLs');
  }
  if (functionsUseOrigin) {
    return `${functionsConnect.replace(/\/$/, '')}/${name}`;
  }
  return `https://${functionsConnect}-${pid}.cloudfunctions.net/${name}`;
}
export const googleProvider = new GoogleAuthProvider();
export const firestore = getFirestore(app);
export const storage = getStorage(app);

// Persistence désactivée pour éviter le bug Firestore "Unexpected state" (ca9/b815)
// avec plusieurs listeners + navigation. Réactiver quand le SDK sera corrigé:
// import { enableIndexedDbPersistence } from 'firebase/firestore';
// enableIndexedDbPersistence(firestore).catch(() => {});

export { app };
export default app;
